export function getURL() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
